import { render } from "./DigitalniOtiskovani.vue?vue&type=template&id=711f2cc7"
import script from "./DigitalniOtiskovani.vue?vue&type=script&lang=js"
export * from "./DigitalniOtiskovani.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__